/**
 * origin الموحَّد لكلّ روابط المشاركة الخارجيّة (Instagram/TikTok/WhatsApp/Email).
 * الدومين الرسميّ للمشروع هو `https://lecmo.com`.
 */
export const PUBLIC_SITE_ORIGIN = "https://lecmo.com";

/**
 * origin المستخدَم لروابط webhooks الواردة من خدمات خارجيّة.
 * يجب أن يكون origin يستجيب مباشرةً بلا أيّ redirect (UpPromote/Shopify يرفضان التحويلات).
 */
export const PUBLIC_WEBHOOK_ORIGIN = PUBLIC_SITE_ORIGIN;
